import { ColorMode } from '../../core/interfaces/color-mode';
import { convertToRgba } from '../../core/utils/colors';
import { useActiveTheme } from '../../theming/hooks/themeProvider';

export default function useEntityLogoBg(primaryColor, darkModePrimaryColor) {
  const colorMode = useActiveTheme();

  if (colorMode === ColorMode.DARK && darkModePrimaryColor) {
    return convertToRgba(darkModePrimaryColor, 0.15);
  }

  return convertToRgba(primaryColor, 0.1);
}
